module.exports = __webpack_public_path__ + "media/images/front/icon_pr-7f04e24f6ddd22494312ebfcd7a7800d.png";